"use client";
import { motion } from "framer-motion";

interface CategoryCardSkeletonProps {
    index?: number;
}

export default function CategoryCardSkeleton({ index = 0 }: CategoryCardSkeletonProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
                delay: index * 0.1,
                duration: 0.5,
                ease: "easeOut"
            }}
            className="group"
        >
            <div className="group flex flex-row items-center gap-5 w-full rounded-lg border border-alsero-light-gray/20 overflow-hidden bg-white">
                {/* Image skeleton */}
                <div className="relative h-[190px] w-[190px] shrink-0 rounded-lg overflow-hidden">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse" />
                </div>
                
                {/* Content skeleton */}
                <div className="w-full font-sans p-4">
                    <div className="h-8 bg-gray-300 rounded mb-2 animate-pulse" style={{ width: '70%' }} />
                    <div className="h-5 bg-gray-200 rounded animate-pulse" style={{ width: '50%' }} />
                </div>
            </div>
        </motion.div>
    );
}
